/**
 * @module
 */
module.exports = {
    GA4_ID_TYPE_USER_ID: 'ga4_id_type_user_id',
    GA4_ID_TYPE_DEVICE_ID: 'ga4_id_type_device_id',
};
